/**
 * @fileoverview Shared react-select style factories for Register dropdowns.
 * @module pages/register/registerSelectStyles
 */
import { createRegisterSelectOptionStyle, hideSelectIndicatorSeparator } from "./registerFormHelpers.js";

const baseControlStyles = (width, extra = {}) => (baseStyles) => ({
  ...baseStyles,
  borderRadius: "8px",
  borderColor: "#909092",
  width,
  height: "30px",
  fontSize: "16px",
  cursor: "pointer",
  textOverflow: "ellipsis",
  textWrap: "nowrap",
  textAlign: "left",
  maxLines: 1,
  ...extra,
});

export const createNotSingleSelectStyles = (width, extraControl = {}) => ({
  control: baseControlStyles(width, extraControl),
  container: (baseStyles) => ({ ...baseStyles }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    maxWidth: "300px",
  }),
  input: (baseStyles) => ({ ...baseStyles }),
  option: createRegisterSelectOptionStyle,
  indicatorSeparator: hideSelectIndicatorSeparator,
});

export const createSingleSelectStyles = (width) => ({
  control: baseControlStyles(width),
  container: (baseStyles) => ({ ...baseStyles }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    maxWidth: "600px",
  }),
  input: (baseStyles) => ({ ...baseStyles }),
  option: createRegisterSelectOptionStyle,
  indicatorSeparator: hideSelectIndicatorSeparator,
});
